import React, {useState} from "react";
import {useForm} from "react-hook-form";
import ProfitMarginFields from "./ProfitMarginFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const profitMarginFields = <ProfitMarginFields {...{register, errors, control, watch, data}} />;

  return {
    setErrors,
    profitMarginFields,
    handleSubmit,
    setData,
    reset,
  }
}